import { useSuspenseQuery } from "@apollo/client/react";

import {
  SearchGeoItemsForListDocument,
  type SearchGeoItemsForListQuery,
  type SearchGeoItemsForListQueryVariables,
} from "~/features/geoItems/gqls";
import { useTenant } from "~/features/tenant/context";

interface UseGeoItemListArgs {
  label?: string;
  pageIndex: number;
  pageSize: number;
}

export function useGeoItemList({ label, pageIndex, pageSize }: UseGeoItemListArgs) {
  const { tenantId } = useTenant();
  if (!tenantId) throw new Error("Tenant ID is required");

  return useSuspenseQuery<SearchGeoItemsForListQuery, SearchGeoItemsForListQueryVariables>(
    SearchGeoItemsForListDocument,
    {
      variables: {
        input: {
          tenantId,
          label,
          statuses: ["init", "draft", "published"],
          limit: pageSize,
          offset: pageIndex * pageSize,
        },
      },
      fetchPolicy: "network-only",
    },
  );
}
